import React from "react";
import styles from "./OfferValueCell.module.css";
import {OfferInListDTO, OfferType, SubtractionType} from "../../../../../../../api/generated";

interface OfferValueCellProps {
    offer: OfferInListDTO
}

export const OfferValueCell: React.FC<OfferValueCellProps> = ({offer}) => {

    if (offer.offerType === OfferType.NewVehicle) {
        const monthlyPayments = offer.monthlyPayments!;
        return <div className={styles.wrapper}>
            <span>£{monthlyPayments}/mo</span>
        </div>
    } else {
        const discount = offer.discount!;
        const subtractionType = discount.subtractionType;
        const subtractionValue = discount.subtractionValue;
        if (subtractionType === SubtractionType.Number) {
            return <div className={styles.wrapper}>
                <span>£{subtractionValue}</span>
            </div>
        } else {
            return <div className={styles.wrapper}>
                <span>{subtractionValue}%</span>
            </div>
        }
    }
}
